export enum ExperimentEnrolmentSchema {
  v1_0_0 = 'iglu:co.zip.common/experiment_enrolment/jsonschema/1-0-0',
}

export type ExperimentEnrolmentEvent = {
  /** unique identifier for the experiment */
  experiment_id: string;
  /** unique identifier for the variation */
  variation_id: string;
};

export enum UIClickSchema {
  v1_0_0 = 'iglu:co.zip.common/user_action_click/jsonschema/1-0-2',
}

export enum FunnelIdentifiers {
  v1_0_2 = 'iglu:co.zip.funnel/funnel_identifiers/jsonschema/1-0-2',
}

export enum FunnelStartSchema {
  v1_0_4 = 'iglu:co.zip.funnel/funnel_start/jsonschema/1-0-4',
}

export enum FunnelOutcomeSchema {
  v1_0_1 = 'iglu:co.zip.funnel/funnel_outcome/jsonschema/1-0-1',
}

export enum SectionStartSchema {
  v1_0_1 = 'iglu:co.zip.funnel/section_start/jsonschema/1-0-1',
}

export enum SectionOutcomeSchema {
  v1_0_1 = 'iglu:co.zip.funnel/section_outcome/jsonschema/1-0-1',
}

type UIEventProperty = string | null;
export type UIClickEventData = {
  /**
   *
   * `id` or `data-testid` attribute of the clicked HTML element.
   *
   * ### Schema Definition
   * The ID of the element being interacted with.
   * Specifically used when there are multiple buttons on page that may do the same thing
   * but need to be distinguished individually in the tracking.
   *
   */
  control_id: UIEventProperty;

  /**
   *
   * HTML tag declarative name or Origin name, e.g. `button`, `link`, `accordion`.
   *
   * ### Schema Definition
   * The type of asset thats being interacted with; text, button, image, tile etc...
   *
   */
  control_type: UIEventProperty;

  /**
   *
   * The state of the action (i.e. interaction).
   *
   * ### Schema Definition
   * The purpose for the action taking placing e.g navigate, confirm, cancel, etc..
   *
   */
  action_type: UIEventProperty;

  /**
   *
   * Plaintext that is found inside a clickable element.
   *
   * ### Schema Definition
   * The copy on the button or link or the alt tag on the image.
   *
   */
  label: UIEventProperty;

  /**
   *
   * Populated when `control_type === link`
   *
   * ### Schema Definition
   * For web clicks this is the full url being clicked
   *
   */
  destination_target_url: UIEventProperty;
};

export enum UIInputSchema {
  v1_0_0 = 'iglu:co.zip.common/user_action_input/jsonschema/1-0-0',
}

export type UIInputEventData = {
  /**
   *
   * `id` or `data-testid` attribute of the input HTML element.
   *
   * ### Schema Definition
   * The ID of the element being interacted with.
   * Specifically used when there are multiple inputs on page that may do the same thing
   * but need to be distinguished individually in the tracking.
   *
   */
  control_id: UIEventProperty;

  /**
   *
   * HTML tag declarative name or Origin name, e.g. `input`, `select`
   *
   * ### Schema Definition
   * The UI method of the input taking place; drop_down, slider, text_field, toggle etc...
   *
   */
  input_type: UIEventProperty;

  /**
   *
   * Label associated with the input element.
   *
   * ### Schema Definition
   * The copy or name of the field where the input is taking place
   *
   */
  label: UIEventProperty;

  /**
   *
   * Current value of the input.
   *
   * ### Schema Definition
   * The value of the input being entered
   *
   */
  new_value: UIEventProperty;

  /**
   *
   * Previous value of the input.
   *
   * ### Schema Definition
   * The old value if applicable
   *
   */
  previous_value: UIEventProperty;
};

export type FunnelIdentifiersEventData = {
  funnel_instance_id: string;
  consumer_id?: string | null;
  customer_id?: string | null;
  account_id?: string | null;
  checkout_id?: string | null;
  device_id?: string | null;
};

export type FunnelStartEventData = {
  funnel_instance_id: string;
  funnel_type: string;
  funnel_source?: string | null;
};

export type FunnelOutcomeEventData = {
  funnel_instance_id: string;
  outcome: 'success' | 'failure';
  outcome_reason?: string | null;
  attempted_with?: string | null;
};

export type SectionStartEventData = {
  section_instance_id: string;
  section_name: string;
  is_server_side_section: boolean;
};

export type SectionOutcomeEventData = {
  section_instance_id: string;
  section_name: string;
  outcome: 'success' | 'failure';
  outcome_reason?: string | null;
  attempted_with?: string | null;
  is_server_side_section: boolean;
};

export enum FunnelSource {
  MobileNav = 'mobile_nav',
  WebNav = 'web_nav',
  ShopFeed = 'shop_feed',
}

export enum Section {
  GiftcardHub = 'giftcard_hub',
  GiftcardDetails = 'giftcard_details',
  GiftcardPurchaseSucess = 'giftcard_success',
}

export type FunnelContext = {
  schema: FunnelIdentifiers;
  data: FunnelIdentifiersEventData;
};
